import { render, staticRenderFns } from "./notesList.vue?vue&type=template&id=37cb6816&scoped=true&"
import script from "./notesList.vue?vue&type=script&lang=js&"
export * from "./notesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cb6816",
  null
  
)

export default component.exports